import { toast } from 'sonner';

// Partagé entre useAdminRealtimeNotifications.js (WebSocket) et
// useWebPushRegistration.js (FCM, message reçu au premier plan) — les deux
// canaux peuvent porter le même événement admin (incident, retard, demande
// parent) au même onglet. Dédoublonne par notification_id pour n'afficher
// qu'un seul toast (et une seule notification OS, voir plus bas) quel que
// soit le canal qui arrive en premier.
const shownNotificationIds = new Set();

// En plus du toast in-app, affiche aussi une notification OS même onglet
// ouvert/focus — Firebase ne le fait jamais automatiquement en foreground
// (contrairement au cas arrière-plan, géré par le service worker), donc pas
// de risque de doublon avec l'auto-affichage. Notification() natif depuis le
// contexte page (pas besoin de service worker) : silencieux si la permission
// n'est pas accordée ou sur un navigateur qui ne supporte pas l'API.
//
// Le clic est géré directement ici (contexte page, pas service worker) —
// donc pas soumis au bypass du listener notificationclick par le SDK
// Firebase rencontré pour le cas arrière-plan (voir fcmService.js::webpushLink).
// `navigate` est optionnel : sans lui, la notification s'affiche mais le
// clic ne fait que rendre le focus à l'onglet (déjà comportement par défaut).
function showNativeNotification(title, message, navigate) {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') {
    return;
  }
  try {
    const notification = new Notification(title, { body: message, icon: '/icons/icon-192.png' });
    if (navigate) {
      notification.onclick = () => {
        window.focus();
        navigate('/admin/notifications');
        notification.close();
      };
    }
  } catch {
    // Certains contextes (ex: ancien Safari) restreignent new Notification() — best-effort.
  }
}

export function showAdminNotificationToastOnce({ id, title, message, navigate }) {
  if (id) {
    if (shownNotificationIds.has(id)) {
      return;
    }
    shownNotificationIds.add(id);
  }
  const resolvedTitle = title || 'Nouvelle notification';
  toast.info(resolvedTitle, { description: message });
  showNativeNotification(resolvedTitle, message, navigate);
}
